import { z } from "zod";

export const siteAnomalies = z.object({
  anomaliesFound: z.boolean(),
});
